import React, { useState } from "react";

const isComment = (entry) => String(entry?.title || "") === "Comment";

const TaskComments = ({ history = [], onSubmit, disabled = false }) => {
    const comments = (Array.isArray(history) ? history : [])
        .filter(isComment)
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    const [text, setText] = useState("");

    const send = () => {
        const body = text.trim();
        if (!body || disabled) return;
        onSubmit?.(body);
        setText("");
    };

    return (
        <div className="task-comments">
            <h3 className="task-comments__title">Comments</h3>
            {comments.length === 0 && (
                <p className="task-comments__empty">No comments yet.</p>
            )}
            <ul className="task-comments__list">
                {comments.map((entry) => (
                    <li key={entry.id || `${entry.createdAt}-${entry.notes}`} className="task-comments__item">
                        <p>{entry.notes}</p>
                        <time>
                            {entry.createdAt
                                ? new Date(entry.createdAt).toLocaleString("en-IN", {
                                      day: "numeric",
                                      month: "short",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                  })
                                : ""}
                        </time>
                    </li>
                ))}
            </ul>
            <div className="task-comments__composer">
                <textarea
                    rows={2}
                    value={text}
                    disabled={disabled}
                    onChange={(e) => setText(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            send();
                        }
                    }}
                    placeholder="Write a comment"
                    aria-label="New comment"
                />
                <button type="button" onClick={send} disabled={disabled || !text.trim()}>
                    Send
                </button>
            </div>
        </div>
    );
};

export default TaskComments;
